export default {
  SET_ACTIVE_STOP_COMMAND (state, payload) {
    state.activeStopCommand = payload
  },
  SET_ACTIVE_LANGUAGE (state, payload) {
    state.activeLanguage = payload
  }
}
